type User = {
  login: string;
  password: string;
  email: string;
  mobileNumber: string;
};

export class Registration {
  constructor(
    public companyName: string,
    public contactPerson: string,
    public country: any,
    public user: User,
  ) {}
}
